// extracted by mini-css-extract-plugin
export var productImage = "_ur-0";